// Until the two modals are unified, we only allow the user to invoke one AddSamples modal
// at a time (or "none").
export enum AddSamplesModalType {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL',
  NONE = 'NONE',
}
